import { State, getDirection } from '@cemex/cmx-client-layout';
import { Store, select } from '@ngrx/store';
import { CX_RTL_TOKEN } from 'app/shared/cx-ui/cx-design-version/cx-design-version.config';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

export const cxRTLProvider = {
  provide: CX_RTL_TOKEN,
  deps: [Store],
  useFactory: (store: Store<State>) => {
    return store.pipe(
      select(getDirection),
      map(dir => dir === 'rtl'),
      distinctUntilChanged(),
      shareReplay(),
    );
  },
};
